import { Components } from "@thisgorilla/primate-ds";
import { useMemo, useState } from "react";
import styled, { useTheme } from "styled-components";
import { useAppSelector } from "../../../../../../redux";
import { addProxyUrlToProfileImage, getPeopleNamesText } from "../../../../../../utils";
import PeopleYouMightKnowProps from "./PeopleYouMightKnow";

export const AvatarGroupAndDescription = ({
  onClick,
}: PeopleYouMightKnowProps.AvatarGroupAndDescriptionProps) => {
  const [isTextHovered, setTextHovered] = useState(false);
  const { typography } = useTheme();
  const { peopleYouMightKnow } = useAppSelector((state) => state.me);

  //#region Data
  const AvatarGroupSrc = useMemo(() => {
    if (!peopleYouMightKnow || !peopleYouMightKnow.length) return [];

    const AvatarGroupSrc = peopleYouMightKnow.map((people) =>
      addProxyUrlToProfileImage(people.profile_picture)
    );

    return AvatarGroupSrc;
  }, [peopleYouMightKnow]);

  const peopleYouMightKnowText = useMemo(
    () => getPeopleNamesText(peopleYouMightKnow),
    [peopleYouMightKnow]
  );
  //#endregion

  return (
    <Container
      onClick={onClick}
      onMouseOver={() => setTextHovered(true)}
      onMouseLeave={() => setTextHovered(false)}
    >
      {AvatarGroupSrc.length > 0 && (
        <Components.AvatarGroup
          size="XSmall-28"
          src={AvatarGroupSrc}
          srcCountToBeRendered={3}
        />
      )}
      <Components.Text
        text={peopleYouMightKnowText}
        style={{ tokenStyle: typography.Body.S }}
        maxLineLength={2}
        isunderlined={isTextHovered}
      />
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => `
  display: flex;
  flex-direction: row;
  gap: 10px;
  border-radius: ${theme.radius["radius-full-round"].value}rem; 
  padding-top: ${theme.spacing["spacing-1"].value}rem;
  padding-right: ${theme.spacing["spacing-2"].value}rem;
  padding-bottom: ${theme.spacing["spacing-1"].value}rem;
  padding-left: ${theme.spacing["spacing-2"].value}rem;

  &:hover {
    background: ${theme.Color.elevation.surface["surface-primary-emphasize-hover"].value};
  }
`
);
